export function compressImage(file, maxWidth, maxHeight, quality) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        image.onload = () => {
            let width = image.width;
            let height = image.height;
            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }
            canvas.width = width;
            canvas.height = height;
            context.drawImage(image, 0, 0, width, height);
            canvas.toBlob(blob => {
                resolve(blob);
            }, 'image/jpeg', quality);
        };
        image.onerror = reject;
        image.src = URL.createObjectURL(file);
    });
}//有损压缩
export function compressFile(file) {
    return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
            quality: 0.6, //压缩质量
            checkOrientation: false, //图片翻转，默认为false
            convertSize: Infinity,
            loose: true,
            redressOrientation: true,
            success(result) {
                resolve(result);
            },
            error(e) {
                reject()
            }
        })
    })
}
export function compressImageWithout(file, maxWidth, maxHeight, quality) {
    return new Promise((resolve, reject) => {
      resolve(file);
    });
  }


// WEBPACK FOOTER //
// ./src/utils/compressImage.js